<template>
    <div>
        <div style="text-align: center;font-size: 1.2rem">
            <span>Copyright © 2021成都瓜甜网络科技有限公司 蜀ICP备2021002240号</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>